import axios from 'axios';

const getValueFromAttributes = (keyName, attributes) => {
  return attributes.reduce(
    (acc, atr) => (acc = atr.name === keyName ? atr.value : acc),
    undefined
  );
};

export default {
  resetSelectedAuthEvents(context) {
    context.commit('SET_SELECTED_AUTH_EVENTS', []);
  },

  getAuthEvents(context, data) {
    axios
      .get(
        `${process.env.VUE_APP_API_URL}/admin/list/${data.type}/${data.username}/events`
      )
      .then(result => {
        context.commit('SET_SELECTED_AUTH_EVENTS', result.data.data);
      })
      .catch(err => {
        console.log(
          `[Dialog${data.type}] - Error trying to getAuthEvents:`,
          err
        );
      });
  },

  removeFromGroup(context, data) {
    axios
      .delete(
        `${process.env.VUE_APP_API_URL}/admin/${data.type}/${data.username}/${data.group}`
      )
      .then(result => {
        console.log(`Successfully removed ${data.type} from group`, data.group);
        this.dispatch('snackbar/update', {
          text: `Successfully removed ${data.type} from group ` + data.group,
          color: 'success',
          open: true
        });
      })
      .catch(err => {
        console.log(
          `Error trying to remove ${data.type} from group ` + data.group,
          err
        );
        this.dispatch('snackbar/update', {
          text: `Error trying to remove ${data.type} from group ` + data.group,
          color: 'warning',
          open: true
        });
      });
  },

  addToGroup(context, data) {
    axios
      .post(
        `${process.env.VUE_APP_API_URL}/admin/${data.type}/${data.username}/${data.group}`
      )
      .then(result => {
        console.log(`Successfully added ${data.type} to group ` + data.group);
        this.dispatch('snackbar/update', {
          text: `Successfully added ${data.type} to group ` + data.group,
          color: 'success',
          open: true
        });
      })
      .catch(err => {
        console.log(
          `Error trying to add ${data.type} to group ` + data.group,
          err
        );
        this.dispatch('snackbar/update', {
          text: `Error trying to add ${data.type} to group ` + data.group,
          color: 'warning',
          open: true
        });
      });
  },

  resetSelectedGroups(context) {
    context.commit('SET_SELECTED_GROUPS', []);
  },

  getCurrentGroups(context, data) {
    axios
      .get(
        `${process.env.VUE_APP_API_URL}/admin/list/${data.type}/${data.username}/groups`
      )
      .then(result => {
        const selectedGroups = result.data.data.map(group => {
          return group.groupName;
        });
        context.commit('SET_SELECTED_GROUPS', selectedGroups);
      })
      .catch(err => {
        console.log(
          `Error trying to GET /admin/list/${data.type}/` +
            data.username +
            '/groups',
          err
        );
      });
  },

  updatePassword(context, data) {
    axios
      .post(
        `${process.env.VUE_APP_API_URL}/admin/${data.type}/${data.username}/attributes/password`,
        {
          password: data.newPassword
        }
      )
      .then(result => {
        this.dispatch('snackbar/update', {
          text: 'Successfully updated password',
          color: 'success',
          open: true
        });
      })
      .catch(err => {
        console.log(
          `Error trying to update ${data.type} password:`,
          err.response
        );
        this.dispatch('snackbar/update', {
          text: `Error trying to change ${data.type} password`,
          color: 'warning',
          open: true
        });
      });
  },

  changeEnabledStatus(context, data) {
    axios
      .post(
        `${process.env.VUE_APP_API_URL}/admin/${data.type}/${data.username}/state/${data.newStatus}`
      )
      .then(result => {
        console.log(`change${data.type}EnabledStatus result:`, result);
        this.dispatch('snackbar/update', {
          text: 'Successfully changed enabled state',
          color: 'success',
          open: true
        });
      })
      .catch(err => {
        console.log(
          `error trying to POST /${data.type}/` +
            data.username +
            '/state/' +
            data +
            ':',
          err
        );
        this.dispatch('snackbar/update', {
          text: 'Error trying to change enabled state',
          color: 'warning',
          open: true
        });
      });
  },

  getAllAvailableByGroupType(context, type) {
    axios
      .get(
        `${process.env.VUE_APP_API_URL}/admin/list/${type.toLowerCase()}/groups`
      )
      .then(result => {
        context.commit('SET_AVAILABLE_GROUPS', {
          type,
          value: result.data.data
        });
      })
      .catch(err => {
        console.log(
          '[store.js] - Error trying to get admin/list/' + type + '/groups',
          err
        );
      });
  },

  getByType(context, type) {
    context.commit('SET_LOADING', true);
    axios
      .get(process.env.VUE_APP_API_URL + `/admin/list/${type}`)
      .then(result => {
        result.data.data.map(member => {
          member.email = getValueFromAttributes('email', member.attributes);
          member.emailVerified = getValueFromAttributes(
            'email_verified',
            member.attributes
          );
          member.phoneNumber = getValueFromAttributes(
            'phone_number',
            member.attributes
          );
          member.phoneNumberVerified = getValueFromAttributes(
            'phone_number_verified',
            member.attributes
          );
          if (type === 'partners')
            member.subId = getValueFromAttributes('sub', member.attributes);
        });
        context.commit('SET_MEMBERS_BY_TYPE', {
          type,
          value: result.data.data
        });
        context.commit('SET_LOADING', false);
      })
      .catch(err => {
        console.log(`Error trying to get admin/list/${type}:`, err);
        context.commit('SET_LOADING', false);
      });
  },

  create(context, memberDetails) {
    axios
      .post(`${process.env.VUE_APP_API_URL}/${memberDetails.type}/register`, {
        username: memberDetails.username,
        password: memberDetails.password
      })
      .then(result => {
        this.dispatch('snackbar/update', {
          text: `Successfully created ${memberDetails.type} ${memberDetails.username}`,
          color: `success`,
          open: true
        });
      })
      .catch(err => {
        if (err.response && err.response.data) {
          this.dispatch('errors/update', {
            state: true,
            message: err.response.data.msg,
            snackbarMessage: `Error trying to create ${memberDetails.type}:\n${err.response.data.msg}`
          });
        } else {
          console.log(
            `Unknown error trying to create ${memberDetails.type}:`,
            err
          );
          this.dispatch('errors/update', {
            state: true,
            message: err,
            snackbarMessage: `Unknown error trying to create ${memberDetails.type}`
          });
        }
      });
  }
};
